module.exports = __webpack_public_path__ + "img/300_SERF_2022_Background.870d455d.png";